export default __webpack_public_path__ + "static/media/kayak_dark.ad7c1e3d.png";